import { type FC } from "react";
import { FormItemName } from "@root/shared/components/FormItemName";
import { InformationText } from "@root/shared/components/InformationText";
import { TextField } from "@root/shared/components/TextField";
import { StepCassette } from "../StepCassette";
import { headingEmphasis } from "../../styles.css";
import * as styles from "./styles.css";

type Props = {
  value: string;
  errorMessage?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Presentation: FC<Props> = ({ value, errorMessage, onChange }) => (
  <StepCassette
    heading={
      <>
        1ヶ月あたり
        <br />
        何人の<span className={headingEmphasis}>顧客</span>を対応していますか？
      </>
    }
  >
    <FormItemName labelRequirementType="required">平均対応客数（月）</FormItemName>
    <span className={styles.textFieldWrapper}>
      <TextField
        name="monthlyCustomers"
        inputMode="numeric"
        value={value}
        onChange={onChange}
        placeholder="半角数字で入力してください"
        hasError={!!errorMessage}
      />
      人
    </span>
    {errorMessage && (
      <InformationText isAlert text={errorMessage} className={styles.errorMessage} />
    )}
  </StepCassette>
);
